<style lang="scss" scoped>
.slide-9 {
  background-image: url(../../../assets/module3/slide9/background-01.jpg);
  background-size: cover;
  background-position: center;
  padding-top: 55px;
  padding-left: 100px;
  padding-right: 100px;
  height: calc(100% - 55px);
}
h1 {
  color: #66368a;
  font-size: 115px;
  line-height: 96px;
  text-align: left;
  margin-bottom: 93px;
  transform: rotate(-2deg);
}
p {
  max-width: 380px;
  position: absolute;
  color: #000;
}
.p2 {
  left: 908px;
  max-width: 420px;
  top: 255px;
  text-align: center;
}
.p3 {
  left: 1409px;
  max-width: 420px;
  top: 255px;
}
.intro {
  margin-bottom: 20px;
}
.dropzone {
  position: absolute;
  width: 200px;
  height: 500px;
  bottom: 180px;
  left: 420px;
}
.drop {
  position: absolute;
  top: -1px;
  width: 100%;
  height: 50%;
  &.drop-1 {
    top: 0;
  }
  &.drop-2 {
    top: 50%;
  }
}
.drag {
  height: 85px;
  width: 85px;
  touch-action: none;
  position: relative;
  z-index: 1 !important;
  img {
    width: 195px;
    height: auto;
    transition: transform 0.2s ease-out;
  }
  &.snapped {
    z-index: 0 !important;
    img {
      transform: rotate(25deg);
    }
    &-hand {
      z-index: 0 !important;
      img {
        transform: rotate(53deg);
      }
    }
  }
}
.instructions {
  text-align: center;
  margin-top: 50px;
  font-size: 34px;
}
.content {
  display: inline-block;
}
h2 {
  color: #c5d43b;
  font-size: 47px;
  line-height: 56px;
  position: absolute;
  bottom: 60px;
  right: 213px;
}
video {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  height: 100%;
  z-index: 0;
  box-shadow: 0px 0px 0px 100vw rgba(0, 0, 0, 0.9);
}
.highfive {
  z-index: 10;
}

.drag-drop {
  position: absolute;
  width: 300px;
  height: 200px;
  left: -25px;
  top: 460px;
}

.drag-container {
  position: absolute;
  top: 425px;
  left: 190px;
  & > div:last-child {
    position: absolute;
    top: 273px;
  }
}

.chars {
  z-index: 1;
}

.high-five {
  position: absolute;
  right: -10px;
  top: 460px;
  width: 300px;
  height: 200px;
  cursor: pointer;
}

.phone {
  position: absolute;
  right: 270px;
  bottom: 120px;
  &__container {
    position: relative;
    width: 100%;
    height: 100%;
  }
  &__number {
    position: absolute;
    width: 41px;
    height: 41px;
    top: 180px;
    cursor: pointer;
    left: 40px;
    &:not(:nth-of-type(-n + 3)):not(:nth-of-type(n + 7)) {
      // Second row
      top: 230px;
    }
    &:not(:nth-of-type(-n + 6)):not(:nth-of-type(n + 10)) {
      // third row
      top: 280px;
    }
    &:nth-of-type(n + 10) {
      // fourt row
      top: 330px;
    }
    &:nth-of-type(3n + 2) {
      // second column
      left: 95px;
    }
    &:nth-of-type(3n + 3) {
      // third column
      left: 152px;
    }
  }
  &__call,
  &__delete {
    width: 40px;
    position: absolute;
    height: 40px;
    left: 94px;
    bottom: 7px;
    cursor: pointer;
  }
  &__delete {
    left: 150px;
  }
  &__screen {
    position: absolute;
    left: 0;
    top: 47px;
    width: 87%;
    text-align: center;
    left: 6%;
    height: 110px;
    font-size: 100px;
    color: #ffffff;
    background: #4d4d4d;
    padding: 30px 0 0;
    border: 0;
    background: #4d4d4d;
    font-family: "Kookycat-FASTcaps";
    box-sizing: border-box;
    &--incorrect {
      animation: flashRed 0.5s;
      animation-iteration-count: 2;
    }
    &--correct {
      animation: flashBlue 0.5s;
      animation-iteration-count: 2;
    }
  }
}

@keyframes flashRed {
  0% {
    background: #e30613;
  }
  50% {
    background: #e30613;
  }
  51% {
    background: inherit;
  }
  100% {
    background: inherit;
  }
}
</style>

<template>
  <div class="slide-9">
    <video
      v-if="showVid"
      ref="video"
      muted
      autoplay
      src="@/assets/module3/slide9/armano_and_the_clot.mp4"
    ></video>

    <video
      v-if="vidFinished"
      loop
      muted
      autoplay
      src="@/assets/module3/slide9/sparks_looping.mp4"
    ></video>

    <video
      v-if="armCurl"
      loop
      muted
      autoplay
      src="@/assets/module3/slide9/armano_arm_curl.mp4"
    ></video>
    <transition name="fade" appear>
      <video
        v-if="show5Vid"
        ref="high5video"
        autoplay
        class="highfive"
        src="@/assets/highfive.mp4"
      ></video>
    </transition>
    <transition name="scale" appear>
      <div v-show="slideIndex == 8">
        <h1 class="txtc" v-html="$t('module3.slide9.heading')"></h1>
      </div>
    </transition>

    <transition name="fadeUp" appear>
      <p v-show="slideIndex == 8 && !showVid" class="p1 delay-3">
        {{ $t("module3.slide9.para1") }}
      </p>
    </transition>

    <transition name="fadeRight" appear>
      <img
        v-if="!showVid"
        v-show="slideIndex == 8"
        src="@/assets/module3/slide9/armando-01.png"
        class="chars delay-2"
      />
    </transition>

    <div class="content drag-container">
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 8" class="delay-4">
          <div class="drag" v-dragArm v-show="!showVid">
            <img src="@/assets/module3/slide9/arm.png" />
          </div>
        </div>
      </transition>
      <transition name="fadeUp" appear>
        <div v-show="slideIndex == 8" class="delay-5">
          <div class="drag" v-dragHand v-show="!showVid">
            <img src="@/assets/module3/slide9/hand.png" />
          </div>
        </div>
      </transition>
    </div>

    <transition name="fadeLeft" appear>
      <div class="delay-6 drag-drop" v-show="slideIndex == 8 && !showVid">
        <img src="@/assets/module3/slide9/drag_drop.svg" />
      </div>
    </transition>

    <transition name="fadeUp" appear>
      <p v-show="showClot" class="p2">
        {{ $t("module3.slide9.para2") }}
      </p>
    </transition>
    <transition name="fadeUp" appear>
      <img
        class="delay-1 chars"
        v-show="showClot"
        src="@/assets/module3/slide9/image-01.png"
      />
    </transition>
    <transition name="fadeRight" appear>
      <p v-show="vidFinished" class="p3 delay-2">
        {{ $t("module3.slide9.para3") }}
      </p>
    </transition>

    <transition name="fadeRight" appear>
      <div class="delay-3 phone" v-show="vidFinished">
        <div class="phone__container">
          <img src="@/assets/module3/slide9/phone-blank.png" class="delay-4" />
          <input
            v-model="dialedNumber"
            type="text"
            maxlength="3"
            class="phone__screen"
            v-bind:class="{
              'phone__screen--incorrect': incorrectNumber,
              'phone__screen--correct': correctNumber
            }"
          />
          <div class="phone__dialpad">
            <div @click.prevent="dialButton('1')" class="phone__number"></div>
            <div @click.prevent="dialButton('2')" class="phone__number"></div>
            <div @click.prevent="dialButton('3')" class="phone__number"></div>
            <div @click.prevent="dialButton('4')" class="phone__number"></div>
            <div @click.prevent="dialButton('5')" class="phone__number"></div>
            <div @click.prevent="dialButton('6')" class="phone__number"></div>
            <div @click.prevent="dialButton('7')" class="phone__number"></div>
            <div @click.prevent="dialButton('8')" class="phone__number"></div>
            <div @click.prevent="dialButton('9')" class="phone__number"></div>
            <div @click.prevent="dialButton('*')" class="phone__number"></div>
            <div @click.prevent="dialButton('0')" class="phone__number"></div>
            <div @click.prevent="dialButton('#')" class="phone__number"></div>
          </div>
          <div @click.prevent="callNumber()" class="phone__call"></div>
          <div @click.prevent="deletePhoneNumber()" class="phone__delete"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// import interact from "interactjs";
import gsap from "gsap";
import Draggable from "gsap/Draggable";

export default {
  props: ["slideIndex"],
  data() {
    return {
      droppableInstance: false,
      point1: false,
      point2: false,
      showVid: false,
      vidFinished: false,
      show5Vid: false,
      dialedNumber: "",
      incorrectNumber: false,
      correctNumber: false,
      armCurl: false,
      showClot: false
    };
  },
  directives: {
    dragArm: {
      inserted(el, binding, vnode) {
        console.log(binding);
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - 205;
              var dy = point.y - 45;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                el.classList.add("snapped");
                return { x: 205, y: -45 };
              }
              el.classList.remove("snapped");
              _this.point1 = false;
              return point;
            },
            rotation: 45
          },
          onDragEnd: function() {
            if (this.endX == 205 && this.endY == -45) {
              console.log(_this);
              _this.point1 = true;
              _this.play();
            }
          }
        });
      }
    },
    dragHand: {
      inserted(el, binding, vnode) {
        let _this = vnode.context;
        gsap.registerPlugin(Draggable);
        Draggable.create(el, {
          type: "x,y",
          liveSnap: {
            points: function(point) {
              var dx = point.x - 160;
              var dy = point.y + 214;
              if (Math.sqrt(dx * dx + dy * dy) < 100) {
                el.classList.add("snapped-hand");
                return { x: 60, y: -214 };
              }
              el.classList.remove("snapped-hand");
              _this.point2 = false;
              return point;
            }
          },
          onDragEnd: function() {
            if (this.endX == 60 && this.endY == -214) {
              _this.point2 = true;
              _this.play();
            }
          }
        });
      }
    }
  },
  mounted() {},
  methods: {
    play() {
      if (!(this.point1 && this.point2)) return;
      this.showVid = true;
      setTimeout(() => (this.showClot = true), 6000);
      this.$nextTick(() => {
        if (this.$refs.video) {
          this.$refs.video.addEventListener(
            "ended",
            () => {
              this.vidFinished = true;
            },
            false
          );
        }
      });
    },
    playHighFive() {
      this.show5Vid = true;
      this.$nextTick(() => {
        if (this.$refs.high5video) {
          this.$refs.high5video.addEventListener(
            "ended",
            () => {
              this.show5Vid = false;
            },
            false
          );
        }
      });
    },
    dialButton(button) {
      if (this.dialedNumber.length < 3) {
        this.correctNumber = false;
        this.incorrectNumber = false;
        this.dialedNumber = this.dialedNumber + button;
      }
    },
    deletePhoneNumber() {
      this.dialedNumber = "";
    },
    callNumber() {
      this.incorrectNumber = false;
      this.correctNumber = false;
      if (this.dialedNumber === "112") {
        this.correctNumber = true;
        this.playHighFive();
        this.armCurl = true;
      } else {
        this.incorrectNumber = true;
        this.dialedNumber = "";
      }
    },
    reload() {
      location.reload();
    }
  }
};
</script>
